module.exports = __webpack_public_path__ + "static/media/22-6.65b7ffc6.mp3";